export enum Status {
    Inactivo = 0,
    Activo = 1,
    Baja = 2
}